export const PROPERTY_TYPES = [
  { value: 'LAND', label: 'Arsa' },
  { value: 'FIELD', label: 'Tarla / Arazi' },
  { value: 'APARTMENT', label: 'Konut / Daire' },
  { value: 'OFFICE', label: 'Ofis' },
  { value: 'WORKPLACE', label: 'İş yeri' },
  { value: 'WAREHOUSE', label: 'Depo' },
  { value: 'FACILITY', label: 'Tesis / Fabrika' },
  { value: 'OTHER', label: 'Diğer' },
];
export const RELATION_TYPES = [
  { value: 'OWNED', label: 'Mülkiyetimizde' },
  { value: 'RENTED', label: 'Kiralanan' },
  { value: 'OTHER', label: 'Diğer' },
];
export const USAGE_STATUSES = [
  { value: 'IN_USE', label: 'Kullanımda' },
  { value: 'VACANT', label: 'Boş' },
  { value: 'RENTED_OUT', label: 'Kiraya verilmiş' },
  { value: 'OTHER', label: 'Diğer' },
];
export const DOCUMENT_TYPES = [
  { value: 'TAPU', label: 'Tapu' },
  { value: 'IMAR', label: 'İmar / Kadastro' },
  { value: 'SOZLESME', label: 'Sözleşme' },
  { value: 'EKSPERTIZ', label: 'Ekspertiz' },
  { value: 'SIGORTA', label: 'Sigorta' },
  { value: 'RUHSAT', label: 'Ruhsat' },
  { value: 'DIGER', label: 'Diğer' },
];
export const lookup = (options, value) => options.find((x) => x.value === value)?.label || value || '—';
export const areaText = (value) => value == null || value === '' ? '—' : `${new Intl.NumberFormat('tr-TR', {maximumFractionDigits: 2}).format(Number(value))} m²`;
export const dateText = (value) => { if (!value) return '—'; const text = String(value); const iso = /^\d{4}-\d{2}-\d{2}$/.test(text) ? text : /(?:Z|[+-]\d{2}:?\d{2})$/.test(text) ? text : `${text.replace(' ', 'T')}Z`; const date = new Date(iso); return Number.isNaN(date.getTime()) ? text : date.toLocaleDateString('tr-TR'); };
export const sizeText = (bytes) => bytes >= 1024 * 1024 ? `${(bytes / 1048576).toFixed(1)} MB` : `${Math.round(bytes / 1024)} KB`;
